import React from "react";
import UserLeftSide from "../UserLogin/UserDoktorLeftSide";
import UserRightSide from "../UserLogin/UserDoktorRightSide";
import './UserPage.css';

const UserPage = () => {
    return (
        <div className="userpage-container">
            <div className="user-content">
                <UserLeftSide />
                <UserRightSide />
            </div>
        </div>
    );
};

export default UserPage;
